import React from 'react';
import Switch from '@ui-library/switch';
import { Flex, FlexProps } from '@ui-library/misc';
import theme from '@css/theme';
import styled from 'styled-components';
import { NewLabel, Subtext } from '@ui-library/typography';

interface Props {
  name: JSX.Element | string;
  description: JSX.Element | string;
  onChange: (value: boolean) => void;
  value: boolean;
  edit: boolean;
}

const Container = styled(Flex).attrs<FlexProps>({
  alignItems: 'center',
  spaceBetween: true,
})`
  padding: 2rem;
  border-bottom: 1px solid ${theme.color.border};
`;

export default ({ name, description, onChange, value, edit }: Props) => {
  const handleOnChange = (checked: boolean) => onChange(checked);

  const getDescription = () => {
    if (typeof description === 'string') {
      return <Subtext data-testid="sub-text">{description}</Subtext>;
    }
    return description;
  };
  const getName = () => {
    if (typeof name === 'string') {
      return <NewLabel data-testid="new-label">{name}</NewLabel>;
    }
    return name;
  };

  return (
    <Container>
      <Flex flexDirection="column" className="m-r-sm">
        {getName()}
        {getDescription()}
      </Flex>
      <Switch data-testid="switch" checked={value} disabled={!edit} onChange={handleOnChange} />
    </Container>
  );
};
